module.exports = __webpack_public_path__ + "static/drying-plants-72825b4c38c58740b70fe4175d3d1773.jpg";